import { render, staticRenderFns } from "./LoaderGrid.component.vue?vue&type=template&id=644fb546&scoped=true&"
import script from "./LoaderGrid.component.vue?vue&type=script&lang=ts&"
export * from "./LoaderGrid.component.vue?vue&type=script&lang=ts&"
import style0 from "./LoaderGrid.component.vue?vue&type=style&index=0&id=644fb546&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644fb546",
  null
  
)

export default component.exports